var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "w-full h-full flex flex-col"
  }, [_c('div', {
    staticClass: "flex-1 overflow-hidden flex"
  }, [_c('div', {
    staticClass: "left-menu xl:w-[232px] md:w-[160px] bg-[#fff] h-full sm:p-2 xl:p-4 border-[1px] border-r-solid border-[#f7f7f7] p-[30px 24px]"
  }, [_c('div', {
    staticClass: "flex relative line-height-[16px] items-center p-2 gap-[10px]",
    on: {
      "click": _vm.goBack
    }
  }, [_c('Icon', {
    staticClass: "border-solid border-[#DCDFE6] p-1 border-[2px] rounded-full",
    attrs: {
      "type": "md-arrow-round-back"
    }
  }), _c('span', {
    staticClass: "text-[20px] font-bold text-[#000] break-all"
  }, [_vm._v($t("cf7dsp4", "应用管理"))])], 1), _c('div', {
    staticClass: "flex flex-col p-2"
  }, _vm._l(_vm.menuList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "left-menu-item flex relative leading-[40px] items-center px-[12px] text-[14px] cursor-pointer",
      class: _vm.active === item.id ? 'active' : '',
      attrs: {
        "href": item.id
      },
      on: {
        "click": function ($event) {
          return _vm.scrollTo(item.id);
        }
      }
    }, [_c('OverflowTooltipText', {
      attrs: {
        "text": item.name || '',
        "max-width": 300,
        "refresh-key": _vm.active === item.id,
        "tooltip-class": "left-menu-item-tooltip"
      }
    })], 1);
  }), 0)]), _c('div', {
    ref: "rightContent",
    staticClass: "right-content h-full p-2 sm:p-2 xl:p-4 flex-1 overflow-y-scroll min-h-0 relative bg-[#fff] border-[1px] border-solid border-r-[#ddd]"
  }, _vm._l(_vm.menuList, function (item) {
    return _c('div', {
      key: item.code,
      ref: item.id,
      refInFor: true,
      staticClass: "flex flex-col child",
      attrs: {
        "id": item.id
      }
    }, [_c('p', {
      staticClass: "text-[16px] font-bold"
    }, [_vm._v(_vm._s(item.name))]), _c('div', {
      staticClass: "grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-4 py-2 sm:py-2 xl:py-4"
    }, _vm._l(item.apps, function (app, index) {
      return _c('div', {
        key: index,
        staticClass: "flex max-h-[150px] overflow-hidden gap-2 items-center px-4 gap-2 max-w-[100%] h-[80px] rounded-md shadow bg-[#f0f2f5] app",
        on: {
          "click": function ($event) {
            return _vm.choice(app);
          }
        }
      }, [_c('img', {
        staticClass: "w-[40px] h-[40px]",
        attrs: {
          "src": app.icon || _vm.defaultImg,
          "alt": ""
        }
      }), _c('text-ellipsis', {
        attrs: {
          "text": app.name
        }
      })], 1);
    }), 0)]);
  }), 0)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };